import {useMemo} from 'react';
import useViewDismissedEvent from '@contentlab/hooks/analytics/use-view-dismissed-event';
import {ViewDismissedEventParams} from '@contentlab/hooks/analytics/use-view-dismissed-event/useViewDismissedEvent';
import useViewPresentedEvent from '@contentlab/hooks/analytics/use-view-presented-event';
import {ViewPresentedEventParams} from '@contentlab/hooks/analytics/use-view-presented-event/useViewPresentedEvent';

interface ViewTransitionEventReturn {
  presented: (params: ViewPresentedEventParams) => void;
  dismissed: (params: ViewDismissedEventParams) => void;
}
/**
 * Custom hook that combines view presented and view dismissed events for one convenient event.
 */
function useViewTransitionEvent(): ViewTransitionEventReturn {
  const {viewPresented} = useViewPresentedEvent();
  const {viewDismissed} = useViewDismissedEvent();

  return useMemo(
    () => ({
      presented: viewPresented,
      dismissed: viewDismissed,
    }),
    [viewPresented, viewDismissed]
  );
}

export default useViewTransitionEvent;
